<template>
  <section class="about-gift-types">
    <AboutPageHeadline
      class="about-gift-types__headline"
      title="GIFT TYPE"
      sub-title="ギフトの種類"
    />
    <div class="about-gift-types__contents">
      <div class="about-gift-types-content">
        <div class="about-gift-types-content__description">
          <div class="about-gift-types-content__icons">
            <img
              src="../../../../../../images/icons/store.svg"
              alt="store icon"
              class="about-gift-types-content__icon"
            />
            <span class="about-gift-types-content__title">店舗受け取り</span>
          </div>
          <p class="about-gift-types-content__text">
            店舗での会計時にチケットを提示して、ギフトの受け取り、またはサービスの提供を受けるタイプのギフトです。人気カフェのドリンクチケットやコンビニお買い物券、リラクゼーションチケットなど幅広いラインナップをご用意しています。
          </p>
        </div>
        <div class="about-gift-types-content__items">
          <div
            v-for="(store, index) in stores"
            :key="index"
            class="about-gift-types-content__item"
          >
            <a :href="store.itemUrlPath">
              <img :src="store.imageUrl" alt="image" />
            </a>
          </div>
        </div>
      </div>
      <div class="about-gift-types-see-more">
        <a
          href="/items?item_receiving_kinds%5B%5D=1"
          class="about-gift-types-see-more__link"
        >
          <span class="about-gift-types-see-more__text">もっとみる</span>
          <ArrowForwardPrimary class="about-gift-types-see-more__icon" />
        </a>
      </div>
    </div>
    <div class="about-gift-types__contents">
      <div class="about-gift-types-content">
        <div class="about-gift-types-content__description">
          <div class="about-gift-types-content__icons">
            <img
              src="../../../../../../images/icons/globe.svg"
              alt="store icon"
              class="about-gift-types-content__icon"
            />
            <span class="about-gift-types-content__title">オンライン利用</span>
          </div>
          <p class="about-gift-types-content__text">
            シリアルコードなどを入力することで、対象のWEBサービスを利用するタイプのギフトです。対象サービスには、各種動画配信サービスをはじめ、オンラインで書籍購入ができるサービス、お子様向けの絵本の情報サービスなどがあります。
          </p>
        </div>
        <div class="about-gift-types-content__items">
          <div
            v-for="(online, index) in onlines"
            :key="index"
            class="about-gift-types-content__item"
          >
            <a :href="online.itemUrlPath">
              <img :src="online.imageUrl" alt="image" />
            </a>
          </div>
        </div>
      </div>
      <div class="about-gift-types-see-more">
        <a
          href="/items?item_receiving_kinds%5B%5D=2"
          class="about-gift-types-see-more__link"
        >
          <span class="about-gift-types-see-more__text">もっとみる</span>
          <ArrowForwardPrimary class="about-gift-types-see-more__icon" />
        </a>
      </div>
    </div>
    <div class="about-gift-types__contents">
      <div class="about-gift-types-content">
        <div class="about-gift-types-content__description">
          <div class="about-gift-types-content__icons">
            <img
              src="../../../../../../images/icons/car.svg"
              alt="store icon"
              class="about-gift-types-content__icon"
            />
            <span class="about-gift-types-content__title">配送</span>
          </div>
          <p class="about-gift-types-content__text">
            受け取り手にお届け先の住所を指定してもらい、配送手配をしてもらうタイプのギフトです。便利な食事配達系サービスのチケットや、話題のお取り寄せグルメ、大勢で楽しんでもらえるような複数詰合せのギフトなどもお選びいただけます。
          </p>
        </div>
        <div class="about-gift-types-content__items">
          <div
            v-for="(delivery, index) in deliveries"
            :key="index"
            class="about-gift-types-content__item"
          >
            <a :href="delivery.itemUrlPath">
              <img :src="delivery.imageUrl" alt="image" />
            </a>
          </div>
        </div>
      </div>
      <div class="about-gift-types-see-more">
        <a
          href="/items?item_receiving_kinds%5B%5D=3"
          class="about-gift-types-see-more__link"
        >
          <span class="about-gift-types-see-more__text">もっとみる</span>
          <ArrowForwardPrimary class="about-gift-types-see-more__icon" />
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import ArrowForwardPrimary from '../../../atoms/svg_icons/ArrowForwardPrimary'
import AboutPageHeadline from '../../../atoms/headlines/AboutPageHeadline'
// stores
import TullysImage from '../../../../../../images/abouts/items/stores/tullys_1.jpg'
import GodivaImage from '../../../../../../images/abouts/items/stores/godiva.jpg'
import IchiranImage from '../../../../../../images/abouts/items/stores/ichiran_1.jpg'
import HanatabaImage from '../../../../../../images/abouts/items/stores/hanataba.jpg'
import HaagendazsImage from '../../../../../../images/abouts/items/stores/lawson_haagendazs.jpg'
import TemominImage from '../../../../../../images/abouts/items/stores/globalsports_1100.jpg'
import AeonCinemaImage from '../../../../../../images/abouts/items/stores/aeon_cinema.jpg'
import JinsImage from '../../../../../../images/abouts/items/stores/jins.jpg'
// online
import RecochokuImage from '../../../../../../images/abouts/items/online/200.jpg'
import UnextImage from '../../../../../../images/abouts/items/online/u-next.png'
import DaznImage from '../../../../../../images/abouts/items/online/dazn_1.jpg'
import DtvImage from '../../../../../../images/abouts/items/online/dtv_1month.jpg'
import EhonImage from '../../../../../../images/abouts/items/online/ehon_1_1.jpg'
import HuluImage from '../../../../../../images/abouts/items/online/hulu.jpg'
import NetflixImage from '../../../../../../images/abouts/items/online/netflix_2000.jpg'
import KangekiImage from '../../../../../../images/abouts/items/online/original.jpg'
// delivery
import MaruhoImage from '../../../../../../images/abouts/items/delivery/maruho.jpg'
import OisixImage from '../../../../../../images/abouts/items/delivery/640x640_Brown.jpg'
import DadwayImage from '../../../../../../images/abouts/items/delivery/dadway.jpeg'
import BluesealImage from '../../../../../../images/abouts/items/delivery/blueseal_d_gift12.jpg'
import CreambreadImage from '../../../../../../images/abouts/items/delivery/creambread_all.jpg'
import KoseImage from '../../../../../../images/abouts/items/delivery/kose_1100.jpg'
import PizzalaImage from '../../../../../../images/abouts/items/delivery/PIZZA-LA.jpg'
import FabricTokyoImage from '../../../../../../images/abouts/items/delivery/tiegift.jpg'

export default {
  components: { AboutPageHeadline, ArrowForwardPrimary },
  data() {
    return {
      stores: [],
      onlines: [],
      deliveries: []
    }
  },
  mounted() {
    this.stores = [
      { imageUrl: TullysImage, itemUrlPath: '/items/1370' },
      { imageUrl: GodivaImage, itemUrlPath: '/items/952' },
      { imageUrl: IchiranImage, itemUrlPath: '/items/747' },
      { imageUrl: HanatabaImage, itemUrlPath: '/items/1435' },
      { imageUrl: HaagendazsImage, itemUrlPath: '/items/1064' },
      { imageUrl: TemominImage, itemUrlPath: '/items/1007' },
      { imageUrl: AeonCinemaImage, itemUrlPath: '/items/1092' },
      { imageUrl: JinsImage, itemUrlPath: '/items/950' }
    ]
    this.onlines = [
      { imageUrl: NetflixImage, itemUrlPath: '/items/973' },
      { imageUrl: HuluImage, itemUrlPath: '/items/746' },
      { imageUrl: KangekiImage, itemUrlPath: '/items/812' },
      { imageUrl: EhonImage, itemUrlPath: '/items/832' },
      { imageUrl: DtvImage, itemUrlPath: '/items/1255' },
      { imageUrl: DaznImage, itemUrlPath: '/items/1189' },
      { imageUrl: UnextImage, itemUrlPath: '/items/943' },
      { imageUrl: RecochokuImage, itemUrlPath: '/items/693' }
    ]
    this.deliveries = [
      { imageUrl: PizzalaImage, itemUrlPath: '/items/1141' },
      { imageUrl: DadwayImage, itemUrlPath: '/items/789' },
      { imageUrl: BluesealImage, itemUrlPath: '/items/1324' },
      { imageUrl: CreambreadImage, itemUrlPath: '/items/855' },
      { imageUrl: MaruhoImage, itemUrlPath: '/items/1143' },
      { imageUrl: OisixImage, itemUrlPath: '/items/1286' },
      { imageUrl: KoseImage, itemUrlPath: '/items/1372' },
      { imageUrl: FabricTokyoImage, itemUrlPath: '/items/1399' }
    ]
  }
}
</script>
<style lang="scss" scoped>
.about-gift-types {
  padding: 40px 5% 80px;
  background-image: url('../../../../../../images/abouts/bg_image/about_pattern.png');
  background-blend-mode: lighten;

  @media all and (max-width: $pc-width  - 1) {
    padding: 40px 24px 80px;
  }

  &__headline {
    margin-bottom: 40px;
  }

  &__contents {
    margin: 0 auto 40px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: $white;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    max-width: calc(1440px - (5% * 2));

    &:last-of-type {
      margin-bottom: 0;
    }

    @media all and (max-width: $pc-width  - 1) {
      padding: 24px 16px;
    }
  }

  &-content {
    display: flex;
    justify-content: center;
    align-items: center;

    @media all and (max-width: $pc-width  - 1) {
      display: block;
    }

    &__description {
      width: 448px;
      margin-right: 16px;

      @media all and (max-width: $pc-width  - 1) {
        width: 100%;
      }
    }

    &__icons {
      margin-bottom: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__icon {
      margin: 0 auto 8px;
      width: 60px;
      height: 60px;

      @media all and (max-width: $pc-width  - 1) {
        margin: 0 auto;
        width: 40px;
        height: 40px;
      }
    }

    &__title {
      font-weight: bold;
      font-size: 2.4rem;
      line-height: 2;
      letter-spacing: 0.06em;

      @media all and (max-width: $pc-width  - 1) {
        font-size: 1.6rem;
      }
    }

    &__text {
      font-size: 1.4rem;
      line-height: 2;
      letter-spacing: 0.04em;
      color: $gray-1;

      @media all and (max-width: $pc-width  - 1) {
        margin-top: 24px;
        font-size: 1.2rem;
      }

      @media all and (max-width: $sp-iphone5-width) {
        font-size: 1rem;
      }
    }

    &__items {
      display: grid;
      grid-template-columns: repeat(4, 25%);

      @media all and (max-width: $pc-width  - 1) {
        margin-top: 12px;
        grid-template-columns: repeat(6, 16.6%);
      }

      @media all and (max-width: $base-contents-width - 1) {
        margin-top: 12px;
        grid-template-columns: repeat(3, 33.3%);
      }
    }

    &__item {
      padding: 12px 8px;
      width: 100%;
      max-width: 198px;
      overflow: hidden;
      box-sizing: border-box;

      a {
        font-size: 0;
      }

      img {
        @extend %hover-common;
        width: 100%;
        border-radius: 8px;
        display: block;
      }

      @media all and (max-width: $pc-width  - 1) {
        &:nth-of-type(7),
        &:nth-of-type(8) {
          display: none;
        }
      }
    }
  }

  &-see-more {
    // NOTE: アイテムにpadding:12px 8pxをしてるので、
    // topは24pxの隙間を作るために12px/rightはアイテムと横位置を揃えるために8pxのmarginをとる
    margin: 12px 8px 0 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media all and (max-width: $pc-width  - 1) {
      // NOTE: アイテムにpadding 12pxをしてるので、topは12px
      margin: 12px auto 0;
    }

    &__link {
      @extend %hover-common;
      display: flex;
      align-items: center;
    }

    &__text {
      margin-right: 8px;
      color: $primary;
      font-weight: bold;
      font-size: 1.6rem;
      line-height: 2;
      letter-spacing: 0.06em;

      @media all and (max-width: $pc-width  - 1) {
        font-size: 1.4rem;
      }

      @media all and (max-width: $sp-iphone5-width) {
        font-size: 1.2rem;
      }
    }

    &__icon {
      width: 24px;
    }
  }
}
</style>
